import { useSelector } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import type { State } from 'Flux/Slice/index.js'
import { createSelector } from '@reduxjs/toolkit'
import type { IPostprocessingInformation } from '../../../../Model/Order/IPostprocessingInformation.js'

export const useGetPostprocessingDataSelector: () => IPostprocessingInformation | null = () => {
  return useSelector(getPostprocessingData)
}

const selectPostprocessingData = (state: typeof State) => state[orderSlice.name].postprocessingData

export const getPostprocessingData = createSelector(selectPostprocessingData, (postprocessingData) =>
  postprocessingData == null ? null : postprocessingData
)
